// This class is responsible for communicating with the
// client library on the parent page. It does this using
// the iframe-resizer and Postie libraries.

import Postie from 'postie'

class ClientLibraryComm {
  constructor(widgetId) {
    this.widgetId = widgetId

    // Initialize Postie instance
    this.in = new Postie()
    this.out = new Postie(window.parent)
  }

  // Public method to send message to client library
  sendMessage(message, ...messageArgs) {
    // Send prefixed message
    this.out.post(`CredibleIframe [${this.widgetId}]: ${message}`, ...messageArgs)
  }

  // Public method to listen for message from client library
  listen(message, callback, once = false) {
    const prefixedMessage = `CredibleSDKCommunicator [${this.widgetId}]: ${message}`

    // Register prefixed listener
    if (once === false) {
      this.in.on(prefixedMessage, callback)
    } else {
      this.in.once(prefixedMessage, callback)
    }
  }

  // Public method to listen once (convenience method)
  listenOnce(message, callback) {
    this.listen(message, callback, true)
  }
}

export default ClientLibraryComm
